<article
  [ngClass]="{
    'card-container': true,
    'hidden-card': establishment.hidden_partnership,
    'own-partnership': establishment.is_own_partnership
  }"
>
  <!-- Partnership Badge -->
  <div class="premium-badge" *ngIf="partnershipBadgeIcon">
    <img
      [src]="partnershipBadgeIcon"
      [alt]="partnershipBadgeAlt"
    />
  </div>

  <div
    [ngClass]="{
      'card-wrapper': true,
      'card-wrapper-no-bg': establishment.image_key?.logo != null
    }"
  >
    <a
      class="image-card"
      *ngIf="establishment.image && !establishment.is_own_partnership"
      [routerLink]="['/parceiro', establishment.slug]"
      [queryParams]="{ address: nearestAddress?.id || nearestAddress?._id }"
      [ngStyle]="{ 'background-image': 'url(' + imagePath + ')' }"
    >
    </a>

    <a
      class="image-card"
      *ngIf="!establishment.image && establishment.is_own_partnership"
      [routerLink]="['/parceiro', establishment.slug]"
      [queryParams]="{ address: nearestAddress?.id || nearestAddress?._id }"
      [ngStyle]="{
        'background-image':
          'url(\'assets/shared/img/parcerias_proprias_bkg.png\')'
      }"
    >
      <span
        >Parceria<br /><b>{{ businessName }}</b></span
      >
    </a>

    <a
      class="image-card"
      *ngIf="establishment.image && establishment.is_own_partnership"
      [routerLink]="['/parceiro', establishment.slug]"
      [queryParams]="{ address: nearestAddress?.id || nearestAddress?._id }"
      [ngStyle]="{ 'background-image': 'url(' + imagePath + ')' }"
    >
    </a>

    <div [ngClass]="{ 'card-content': true, online: online }">
      <div class="card-content-wrapper">
        <a
          [routerLink]="['/parceiro', establishment.slug]"
          [queryParams]="{ address: nearestAddress?.id || nearestAddress?._id }"
        >
          <h2
            tooltip="{{ establishment.name }}"
            placement="bottom"
            show-delay="50"
            tooltip-class="tooltip-online"
          >
            {{
              establishment.name.length > 23
                ? (establishment.name | slice : 0 : 22) + "..."
                : establishment.name
            }}
          </h2>
          <div *ngIf="nearestAddress && !online">
            <p *ngIf="nearestAddress.county">
              {{ nearestAddress.county }}
              <span class="distance"
                >({{ nearestAddress.distance | distance }})</span
              >
            </p>
            <p class="address" *ngIf="nearestAddress.nameUnit">
              {{
                nearestAddress.nameUnit.length > 35
                  ? (nearestAddress.nameUnit | slice : 0 : 34) + "..."
                  : nearestAddress.nameUnit
              }}
            </p>
            <p class="address" *ngIf="nearestAddress.street">
              {{ nearestAddress.street }}
            </p>
          </div>
        </a>
        <ul>
          <li
            *ngIf="
              (userRole === 'master' || userRole === 'finance') &&
              establishment.is_own_partnership
            "
            class="view-active"
          >
            <button
              class="btn-hidecard"
              type="button"
              (click)="editOwnPartnership()"
            >
              <span class="fa fa-edit"></span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</article>
